import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import SubdomainRouter from "./routes/SubdomainRouter/v1/SubdomainRouter";
import { checkAuthentication } from "./store/reducers/auth";
import Aux from "./components/Aux/Aux";
import Spinner from "./components/Spinner/v1/Spinner";
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import { AppShell, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import Header from "./components/Headers/Header";
import "./app.css"
import LogPageLoad from './components/Logging/LogPageLoad';
import ModalNotification from "./components/Aux/ModalNotification";

const App = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [authenticating, setAuthenticating] = useState(localStorage.getItem("isAuthenticated") === "true");
    const pathname = window.location.pathname;
    const shellNames = (pathname.includes("customer-hamper-list") ? "employee-customer-list" : "");
    const bypassHamper = pathname.includes("hamper-bypass");

    useEffect(() => {
        if (localStorage.getItem("isAuthenticated") === "true") {
            setLoading(true);
            setAuthenticating(true);
            const validateAuth = async () => {
                await dispatch(checkAuthentication({
                    loading: setLoading,
                    authenticating: setAuthenticating
                }));
            };
            validateAuth().catch(() => setLoading(false));
        }
        else {
            setAuthenticating(false);
        }
    }, [dispatch]);

    return (
        <Aux>
            <MantineProvider theme={{ fontFamily: 'Manrope, sans-serif' }}>
                <Notifications />

                {location.pathname === "/" && <ModalNotification />}

                {loading && <Spinner />}
                <AppShell
                    header={{ height: 60 }}
                    navbar={{ width: 300, breakpoint: 'sm' }}
                    padding="md"
                    className={ shellNames }
                >
                    { !authenticating &&
                        <Aux>
                            <AppShell.Header className="custom-header">
                                <Header isLoading={setLoading} hamperBypass={ bypassHamper } />
                            </AppShell.Header>
                            <AppShell.Main>
                                <LogPageLoad />
                                <SubdomainRouter pageLoading={loading} setLoading={setLoading} />
                            </AppShell.Main>
                        </Aux>
                    }
                    { authenticating &&
                        <Spinner />
                    }
                </AppShell>
            </MantineProvider>
        </Aux>
    );
};

export default App;